/**
 * How the map is driven (#162, the author's playtest note of 28.10.2026: sending a
 * fleet from a MacBook's touchpad was awkward). «Мышь» is the RTS scheme: the wheel
 * zooms, the right button orders. «Тачпад» is a tablet RTS's: two fingers pan, a pinch
 * zooms, and with a ship picked a click on the map orders it there.
 */
export const CONTROL_SCHEMES = ['mouse', 'touchpad'] as const;
export type ControlScheme = (typeof CONTROL_SCHEMES)[number];

const KEY = 'sd.controls';

export function loadControls(): ControlScheme {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === 'mouse' || saved === 'touchpad') return saved;
  } catch {
    // storage can be unavailable (private mode, sandboxed previews)
  }
  return 'mouse';
}

export function saveControls(value: ControlScheme) {
  try {
    localStorage.setItem(KEY, value);
  } catch {
    // ignore
  }
}
